#### Change to HTTP header casing on webhook events

From 28 September 2026, the SEEK API may change the capitalisation of HTTP header names on webhook event requests.

**What is changing?**

The capitalisation of HTTP header names on webhook event requests may change.
For example, a header documented as `Seek-Signature` might be sent with different capitalisation.
Which headers are sent, their names and values will not change.

**Why is this changing?**

HTTP header field names are case-insensitive under [RFC 9110, section 5.1](https://www.rfc-editor.org/rfc/rfc9110.html#section-5.1).
This change aligns the delivery of webhook events with that standard.

**What change is required for partners?**

No change is required if your integration already treats HTTP header names as case-insensitive, per RFC 9110.

If your integration matches HTTP header names case-sensitively, you must update it to match header names case-insensitively, otherwise it may fail to read headers on webhook event requests once this change is in effect.
